import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Browse tile for a published Wissenswelt (Block D). Replicates the WeltCard
 * visual (square hero over a name label on a bg-blue-bg tile) WITHOUT reusing
 * WeltCard directly — WeltCard's `slug` is typed `WorldSlug` (aa/kp/sb) and
 * catalog slugs are `sb-feuerwehr` etc. The hero is rendered 1:1 to match the
 * 1254x1254 source covers — anything wider would crop top/bottom and clip
 * tall motifs (Dinosaurier neck, Mein Körper full body). When `coverSrc` is
 * null the placeholder shows the shared bg-dream-navy/10 + Sparkles.
 */
export interface CatalogWorldTileProps {
  worldSlug: string;
  title: string;
  /** Cover image URL once world images land; null today → placeholder. */
  coverSrc?: string | null;
  onClick: () => void;
  className?: string;
  testId?: string;
}

export function CatalogWorldTile({
  worldSlug,
  title,
  coverSrc,
  onClick,
  className,
  testId,
}: CatalogWorldTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex flex-1 flex-col overflow-hidden rounded-lg bg-blue-bg text-left transition-transform hover:scale-[1.01] focus-visible:outline-2 focus-visible:outline-dream-navy/50',
        className,
      )}
      data-testid={testId}
      data-world-slug={worldSlug}
    >
      <div className="relative aspect-square w-full">
        {coverSrc ? (
          <img src={coverSrc} alt="" className="h-full w-full object-cover" draggable={false} />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center bg-dream-navy/10">
            <Sparkles aria-hidden className="h-6 w-6 text-dream-navy/40" />
          </div>
        )}
      </div>
      <div className="flex w-full flex-col items-start px-3 py-4">
        <p className="w-full text-xs font-medium leading-3 text-dream-navy">{title}</p>
      </div>
    </button>
  );
}
